import lodash from "lodash";
import { normalizeDigits } from "./generalUtils.js";

export function effectForUpdatingRestFieldsBasedOnItems(pageStateDummy, isFreightEditable = false, freightOverridden = false) {
  let needsUpdate = false;
  let total_weight = 0;
  let total_amount = 0;
  let total_pkgs = 0;
  let updatedPageState = {};

  pageStateDummy["item_in"].forEach((item) => {
    let weight = parseFloat(normalizeDigits(item.weight));
    let pkgs = parseFloat(normalizeDigits(item.pkgs));
    let amount = parseFloat(item.amount);

    if (!isNaN(amount)) {
      total_amount += amount;
    }

    if (!isNaN(weight) && !isNaN(pkgs)) {
      total_weight += weight;
    }

    if (!isNaN(pkgs)) {
      total_pkgs += pkgs;
    }
  });

  if (
    process.env.REACT_APP_CLIENT != "xpress" &&
    process.env.REACT_APP_CLIENT != "guru" &&
    process.env.REACT_APP_CLIENT != "g_trans"
  ) {
    if (total_weight != parseFloat(pageStateDummy["charge_weight"])) {
      updatedPageState["charge_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }

  if (
    process.env.REACT_APP_CLIENT == "guru" ||
    process.env.REACT_APP_CLIENT == "nrab" || 
    process.env.REACT_APP_CLIENT == "syt" ||
    process.env.REACT_APP_CLIENT == "sangam"
  ) {
    if (total_weight != parseFloat(pageStateDummy["actual_weight"])) {
      updatedPageState["actual_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }

  let roundedFreight = total_amount;

  // Apply rounding only for Arbuda client
  if (process.env.REACT_APP_CLIENT === "arbuda") {
    roundedFreight = Math.ceil(total_amount / 5) * 5;
  }

  if (isFreightEditable && freightOverridden) {
    // Freight was manually overridden by user - preserve their value
  } else {
    if (roundedFreight != parseFloat(pageStateDummy["freight"])) {
      updatedPageState["freight"] = String(roundedFreight);
      needsUpdate = true;
    }
  }

  if (total_pkgs != parseFloat(pageStateDummy["no_of_package"])) {
    updatedPageState["no_of_package"] = String(total_pkgs);
    needsUpdate = true;
  }

  return [needsUpdate, updatedPageState];
}

export function effectForUpdatingTotalAmount(pageStateDummy) {
  let needsUpdate = false;
  let freight = pageStateDummy["freight"];
  let hamali = pageStateDummy["hamali"];
  let door_del_charge = pageStateDummy["door_del_charge"];
  let crossing_charge = pageStateDummy["crossing_charge"];
  let bilty_charge = pageStateDummy["bilty_charge"];
  let other_amount = pageStateDummy["other_amount"];
  let lc_charge = pageStateDummy["lc_charge"];
  let total_amount = pageStateDummy["total_amount"];
  let rto = pageStateDummy["rto"]
  let loading_charge = pageStateDummy["loading_charge"]
  let unloading_charge = pageStateDummy["unloading_charge"]
  let advance = pageStateDummy["advance"]
  let detention = pageStateDummy["detention"]
  let pf = pageStateDummy["pf"];
  // let discount = pageStateDummy["discount"] || "0";
  let updatedPageState = {};

  freight = normalizeDigits(freight);
  hamali = normalizeDigits(hamali);
  lc_charge = normalizeDigits(lc_charge);
  door_del_charge = normalizeDigits(door_del_charge);
  crossing_charge = normalizeDigits(crossing_charge);
  bilty_charge = normalizeDigits(bilty_charge);
  other_amount = normalizeDigits(other_amount);
  pf = normalizeDigits(pf);
  rto = normalizeDigits(rto);
  loading_charge = normalizeDigits(loading_charge);
  unloading_charge = normalizeDigits(unloading_charge);
  advance = normalizeDigits(advance);
  detention = normalizeDigits(detention);
  total_amount = normalizeDigits(total_amount);

  if (freight == "") {
    freight = 0;
  } else {
    freight = parseFloat(freight);
  }

  if (hamali == "") {
    hamali = 0;
  } else {
    hamali = parseFloat(hamali);
  }
  if (lc_charge == "") {
    lc_charge = 0;
  } else {
    lc_charge = parseFloat(lc_charge);
  }
  if (door_del_charge == "") {
    door_del_charge = 0;
  } else {
    door_del_charge = parseFloat(door_del_charge);
  }

  if (crossing_charge == "") {
    crossing_charge = 0;
  } else {
    crossing_charge = parseFloat(crossing_charge);
  }

  if (bilty_charge == "") {
    bilty_charge = 0;
  } else {
    bilty_charge = parseFloat(bilty_charge);
  }

  if (other_amount == "") {
    other_amount = 0;
  } else {
    other_amount = parseFloat(other_amount);
  }

  if (pf == "") {
    pf = 0;
  } else {
    pf = parseFloat(pf);
  }

  if (rto == "") {
    rto = 0;
  } else {
    rto = parseFloat(rto);
  }

  if (loading_charge == "") {
    loading_charge = 0;
  } else {
    loading_charge = parseFloat(loading_charge);
  }

  if (unloading_charge == "") {
    unloading_charge = 0;
  } else {
    unloading_charge = parseFloat(unloading_charge);
  }
  
  if (advance == "") {
    advance = 0;
  } else {
    advance = parseFloat(advance);
  }

  if (detention == "") {
    detention = 0;
  } else {
    detention = parseFloat(detention);
  }

  if (total_amount == "") {
    total_amount = 0;
  } else {
    total_amount = parseFloat(total_amount);
  }

  let calculatedTotalAmount = 0;

  if(pageStateDummy.is_crossing == "N"){
    if(process.env.REACT_APP_CLIENT == "gdala_log") {
      calculatedTotalAmount = Math.round(freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge);
    }
    else if(process.env.REACT_APP_CLIENT == "xpress"){
      calculatedTotalAmount = Math.round(freight + hamali + detention + loading_charge + unloading_charge + rto - advance);
    }
    else {
      if(process.env.REACT_APP_CLIENT == "xpress"){
        calculatedTotalAmount = Math.round(freight + hamali + detention + rto - advance);
      }
      else if (process.env.REACT_APP_CLIENT != "xpress") {
        calculatedTotalAmount =
          freight +
          hamali +
          door_del_charge +
          bilty_charge +
          other_amount +
          lc_charge;

        if (process.env.REACT_APP_CLIENT === "bbac") {
          calculatedTotalAmount += crossing_charge;
        }

        if (process.env.REACT_APP_CLIENT === "bgtc") {
          calculatedTotalAmount += pf;
        }
      }
    }
  }
  else {
    calculatedTotalAmount = freight + hamali + door_del_charge + other_amount + lc_charge;

    if (process.env.REACT_APP_CLIENT === "bbac") {
      calculatedTotalAmount += crossing_charge;
    }
  }

  // if (process.env.REACT_APP_CLIENT === "guru") {
  //   let discountPercentage = 0;
    
  //   if (discount === "1") {
  //     discountPercentage = 25;
  //   } else if (discount === "2") {
  //     discountPercentage = 50;
  //   } else {
  //     discountPercentage = 0;
  //   }

  //   if (discountPercentage > 0) {
  //     calculatedTotalAmount = calculatedTotalAmount - (calculatedTotalAmount * discountPercentage) / 100;
  //   }

  //   calculatedTotalAmount = Math.round(calculatedTotalAmount * 100) / 100;
  // }

  const tolerance = 0.01;
  if (Math.abs(calculatedTotalAmount - total_amount) > tolerance) {
    updatedPageState["total_amount"] = String(calculatedTotalAmount);
    needsUpdate = true;
  }

  return [needsUpdate, updatedPageState];
}

export function effectForRowWiseAmount(pageStateDummy) {
  let newItems = [];
  let needsUpdate = false;
  let updatedPageState = {};
  pageStateDummy.item_in.forEach((item) => {
    let newItem = {};
    if (item.unit == "") {
      newItems.push(item);
      return;
    } else if (item.unit == "w" || item.unit == "W") {
      if (item.weight == "" || item.rate == "" || item.pkgs == "") {
        newItems.push(item);
        return;
      }
      let pkgs = parseFloat(normalizeDigits(item.pkgs));
      let weight = parseFloat(normalizeDigits(item.weight));
      let rate = parseFloat(normalizeDigits(item.rate));
      let amount = parseFloat(item.amount);
      if (isNaN(pkgs) || isNaN(weight) || isNaN(rate)) {
        newItems.push(item);
        return;
      }
      let calculatedAmount = (weight * rate).toFixed(2);
      if (isNaN(amount)) {
        needsUpdate = true;
        newItem = { ...item, amount: calculatedAmount };
        newItems.push(newItem);
      } else if (amount != calculatedAmount) {
        needsUpdate = true;
        newItem = { ...item, amount: calculatedAmount };
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    } else if (item.unit == "c" || item.unit == "C") {
      if (item.pkgs == "" || item.rate == "") {
        newItems.push(item);
        return;
      }
      let pkgs = parseFloat(normalizeDigits(item.pkgs));
      let rate = parseFloat(normalizeDigits(item.rate));
      let amount = parseFloat(item.amount);
      if (isNaN(pkgs) || isNaN(rate)) {
        newItems.push(item);
        return;
      }
      if (isNaN(amount)) {
        needsUpdate = true;
        newItem = { ...item, amount: String(pkgs * rate) };
        newItems.push(newItem);
      } else if (amount != pkgs * rate) {
        needsUpdate = true;
        newItem = { ...item, amount: String(pkgs * rate) };
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    } else if (
      item.unit == "f" ||
      item.unit == "F" ||
      item.unit == "t" ||
      item.unit == "T"
    ) {
      if (item.rate == "") {
        newItems.push(item);
        return;
      }
      let rate = parseFloat(normalizeDigits(item.rate));
      let amount = parseFloat(item.amount);
      if (isNaN(rate)) {
        newItems.push(item);
        return;
      }
      if (isNaN(amount)) {
        needsUpdate = true;
        newItem = { ...item, amount: String(rate) };
        newItems.push(newItem);
      } else if (amount != rate) {
        needsUpdate = true;
        newItem = { ...item, amount: String(rate) };
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    }
  });
  if (needsUpdate) {
    updatedPageState = { item_in: newItems };
    return [needsUpdate, updatedPageState];
  } else {
    return [needsUpdate, {}];
  }
}

export function biltyAutoUpdationEffectsDummy(pageStateDummy, isFreightEditable = false, freightOverridden = false) {
  let updatedPageState = {};
  let updatedPageStateTotal = {};
  let needsUpdate = false;
  let tempNeedsUpdate = false;
  [tempNeedsUpdate, updatedPageState] = effectForRowWiseAmount(pageStateDummy);
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }
  [tempNeedsUpdate, updatedPageState] = effectForUpdatingRestFieldsBasedOnItems(
    { ...pageStateDummy },
    isFreightEditable,
    freightOverridden
  );
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  [tempNeedsUpdate, updatedPageState] = effectForUpdatingTotalAmount({
    ...pageStateDummy,
  });
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  if (needsUpdate) {
    return [needsUpdate, updatedPageStateTotal];
  } else {
    return [needsUpdate, {}];
  }
}

export function additionalFilterOnInputForBilty(inputObject,methodType) {
    // let biltyDate = new Date(inputObject.bilty_date);


    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date(inputObject.bilty_date ?? new Date()).getTime() - tzoffset)).toISOString().slice(0, -1);

    inputObject.bilty_date = localISOTime;

    // let tmpDate = new Date(biltyDate).toLocaleString('sv');
  
  if(process.env.REACT_APP_CLIENT == "shubham" || process.env.REACT_APP_CLIENT == "nptc" || process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam" || process.env.REACT_APP_CLIENT == "sra") {
    if(inputObject.destination == "" && inputObject.destination_name == "") {
      inputObject.destination = inputObject.station_to
      inputObject.destination_name = inputObject.station_to_name
    }
    else if(inputObject.destination && inputObject.destination_name) {
      inputObject.destination = inputObject.station_to
      inputObject.destination_name = inputObject.station_to_name
    }
  }

  if (process.env.REACT_APP_CLIENT === "bgtc") {
    inputObject.destination = inputObject.station_to;
    inputObject.destination_name = inputObject.station_to_name;
  }

  if(process.env.REACT_APP_CLIENT == "vihira" || process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
    if(inputObject.billing_party == "" && inputObject.billing_party_name == "") {
      inputObject.billing_party_name = inputObject.consignor_name
      inputObject.billing_party = inputObject.consignor_id
    }
    else if(inputObject.billing_party && inputObject.billing_party_name) {
      inputObject.billing_party_name = inputObject.consignor_name
      inputObject.billing_party = inputObject.consignor_id
    }
  }

  if(process.env.REACT_APP_CLIENT == "guru") {
    if(inputObject.pf == "") {
      inputObject.pf = "0";
    }
  }

  if(process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
    if(inputObject.add == "") {
      inputObject.add = "0";
    }
    if(inputObject.charge_weight == "") {
      inputObject.charge_weight = "0";
    }
    else if(inputObject.charge_weight) {
      inputObject.charge_weight = "0";
    }
  }

  if ("item_in" in inputObject) {
    inputObject.item_in = inputObject.item_in.map((item) => ({
      ...item,
      weight: item.weight ? parseFloat(normalizeDigits(item.weight)) : 0,
    }));
  }

  if (
    inputObject.eway_bill_info &&
    inputObject.eway_bill_info.length == 1 &&
    inputObject.eway_bill_info[0].eway_bill_no == ""
  ) {
    delete inputObject.eway_bill_info;
  }

  if (inputObject.actual_weight == "" || inputObject.actual_weight == null) {
  
    const clientsUsingChargeWeight = ["avr", "std", "bgtc", "nptc", "nrab", "syt", "sangam", "arbuda", "bbac", "jtsa"];

    if (clientsUsingChargeWeight.includes(process.env.REACT_APP_CLIENT)) {
      inputObject.actual_weight = inputObject.charge_weight;
    } else {
      inputObject.actual_weight = "0";
    }
  }
  
  if (inputObject.actual_weight == "") { 
    inputObject.actual_weight = "0"; 
  }

  if (
    inputObject.consignor_gst == "N.A" ||
    inputObject.consignor_gst == "n.a"
  ) {
    inputObject.consignor_gst = null;
  }
  if (
    inputObject.consignee_gst == "N.A" ||
    inputObject.consignee_gst == "n.a"
  ) {
    inputObject.consignee_gst = null;
  }

  let dummyObject = lodash.cloneDeep(inputObject);

  if (dummyObject.is_crossing == "N" || dummyObject.is_crossing == "n") {
    dummyObject.transporter_id = null;
    dummyObject.transporter_name = null;
    // dummyObject.suffix = null;
  }
  delete dummyObject.is_crossing;

  // Removing entries with blank string.
  for (let key in dummyObject) {
    if(process.env.REACT_APP_CLIENT == "gdala_log"){
      if (dummyObject[key] == "" && key != "no_of_package") {
        dummyObject[key] = null;
      }
    }
    else {
      if (key !== "charge_weight" && dummyObject[key] == "") {
        dummyObject[key] = null;
      }
    }
  }

  // Removing new row from tables
  if ("item_in" in dummyObject) {
    for (let i = 0; i < dummyObject.item_in.length; i++) {
      delete dummyObject.item_in[i].new_row;
    }
  }
  if ("eway_bill_info" in dummyObject && dummyObject.eway_bill_info != null) {
    for (let i = 0; i < dummyObject.eway_bill_info.length; i++) {
      delete dummyObject.eway_bill_info[i].new_row;
    }
  }
  if(!dummyObject.suffix) {
      dummyObject.suffix = "null";
  }

  if(process.env.REACT_APP_CLIENT == "gdala_log") {
    if (methodType === "POST") {
      dummyObject.bilty_no = null;
    }
  }
//   if(dummyObject.suffix)
  return dummyObject;
}

export function additionalFilterOnResponseForGetEwb(inputObject) {
  return inputObject.eway_bill_info[0];
}
